import type { ReactNode } from 'react'

export type PaymentMethodExpandableSectionProps = {
  isExpanded: boolean
  children: ReactNode
}

/** Animates expand/collapse of extra content (e.g. linked bank) under a selected UPI app. */
export function PaymentMethodExpandableSection({
  isExpanded,
  children,
}: PaymentMethodExpandableSectionProps) {
  return (
    <div
      className={`grid transition-[grid-template-rows] duration-200 ease-out ${isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
    >
      <div className='overflow-hidden'>
        <div
          className={`transition-opacity duration-200 ease-out ${isExpanded ? 'opacity-100' : 'opacity-0'
            }`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
